module.exports = __webpack_public_path__ + "img/ollie.bcd4a81a.png";